module.exports = __webpack_public_path__ + "img/wx-public.89efd32e.png";